<button kendoButton (click)="submitLogin()">Facebook Authentication</button>
<button kendoButton (click)="signout()">signout</button>